import Container from '@components/ui/layout/Container'
import SmallContainer from '@components/ui/layout/SmallContainer'
import { Heading, Text } from '@components/ui/typography'
import React, { FC } from 'react'
import { AboutUsSingleton } from '__generated__/sanity'
import { Member } from './Member'
import * as styles from './styles'

type MeetTheTeamProps = AboutUsSingleton['fields']['meetTheTeam']

export const MeetTheTeam: FC<MeetTheTeamProps> = ({
  meetTheTeamTitle,
  meetTheTeamDescription,
  meetTheTeamMembers,
}) => {
  return (
    <>
      <SmallContainer as="div">
        <Heading variant="h3" as="h3" className={styles.mainHeading}>
          {meetTheTeamTitle}
        </Heading>
        <Text variant="bodyLarge" as="h3" className={styles.mainText}>
          {meetTheTeamDescription}
        </Text>
      </SmallContainer>
      <Container className={styles.grid} as="ul">
        {meetTheTeamMembers.map((block, index) => (
          <Member
            image={block.meetTheTeamMemberImage.asset}
            name={block.meetTheTeamMemberName}
            role={block.meetTheTeamMemberRole}
            key={index}
          />
        ))}
      </Container>
    </>
  )
}
